import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

import type { TimelineEvent, TimelineEventType } from '../../features/variance-tracker/components/variance-supporting-data/models/timeline-event.model';

export interface AddTimelineEventPayload {
  readonly eventType: TimelineEventType;
  readonly message: string;
  readonly incidentRowId?: string | null;
}

export interface TimelineEventsClient {
  getTimelineEvents(caseId: number): Observable<readonly TimelineEvent[]>;
  addEvent?(caseId: number, payload: AddTimelineEventPayload): void;
}

export const TIMELINE_EVENTS_CLIENT = new InjectionToken<TimelineEventsClient>(
  'TIMELINE_EVENTS_CLIENT'
);

